import { lazy } from 'react';

// Types
import { PayPalInvalidAddressModalProps as LazyComponentProps } from './PayPalInvalidAddressModal.types';

// Components
import withSuspense, { lazyRetry } from '../../suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "payPalInvalidAddressModal" */ './PayPalInvalidAddressModal')));

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'PayPalInvalidAddressModal');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as PayPalInvalidAddressModal };
